import { MPARequestListPerspective, MPARequestStatus } from '@repo/api-gw-sdk';
import type { SWRConfiguration } from 'swr';
import { useDAL } from '@/contexts/useDAL';
import { useRoles } from '@/contexts/useRoles';
const BADGE_SWR_OPTIONS: SWRConfiguration = {
  refreshInterval: 60_000,
  revalidateOnFocus: true
};
export const useMpaRequestsCounts = () => {
  const dal = useDAL();
  const {
    isAuthorized
  } = useRoles();
  const {
    data: requests,
    isLoading: isRequestsLoading,
    mutate: mutateRequests
  } = dal.mpa.requests.useList({
    filters: {
      status: MPARequestStatus.MPA_REQUEST_STATUS_PENDING_APPROVAL,
      perspective: MPARequestListPerspective.MPA_REQUEST_LIST_PERSPECTIVE_REVIEWER,
      excludeReviewed: true
    }
  }, undefined, 1, BADGE_SWR_OPTIONS, isAuthorized('update:mpa_requests'));
  const {
    data: myRequests,
    isLoading: isMyRequestsLoading,
    mutate: mutateMyRequests
  } = dal.mpa.myRequests.useList({
    filters: {
      status: MPARequestStatus.MPA_REQUEST_STATUS_APPROVED
    }
  }, undefined, 1, BADGE_SWR_OPTIONS, true);
  const refresh = async () => {
    await Promise.all([mutateRequests(), mutateMyRequests()]);
  };
  return {
    requests,
    myRequests,
    isLoading: isRequestsLoading || isMyRequestsLoading,
    shouldShowCounts: true,
    refresh
  };
};